import { NextSeoTraqq } from '@components/Seo';
import Layout from '@layouts/Layout';
import SwitchToTraqq from '@screens/Ads/SwitchToTraqq';

import React, { memo } from 'react';

const title = 'Discount page';
const description = 'Using a different time tracker, paid a full yearly price and now want to switch? We got a special deal for you too. Click to get started!';

const SwitchToTraqqPage = () => (
    <Layout
        title={ title }
        description={ description }
    >
        <SwitchToTraqq />
        <NextSeoTraqq
            noindex={ true }
            nofollow={ true }
            norobots={ false }
        />
    </Layout>
);

export default memo(SwitchToTraqqPage);
